import React, { useEffect, useRef, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { api } from "../../include/api";
import { ERROR, SUCCESS } from "../../include/constant";
import {
  validateEmail,
  validatePhoneNumber,
} from "../../include/function";
import { useNotification } from "../../Toast/ToastProvider";
import Layout from "../../components/user/Layout";
import { useCart } from "../../components/context/UserCartCountContext";
import LoginSlide from "./LoginSlide";
import "../../styles/Signup.css";
import { Upload, UploadCloud } from "react-feather";

const OTPInput = ({ onSubmit, resendOTP, sentOTP, saving }) => {
  const [otp, setOtp] = useState(new Array(6).fill(""));
  const [error, setError] = useState("");
  const [timeLeft, setTimeLeft] = useState(300);
  const inputRefs = useRef([]);
  const timerRef = useRef(null);

  useEffect(() => {
    inputRefs.current[0]?.focus();
    window.scrollTo({ top: 0, behavior: "smooth" });

    startTimer();

    return () => clearInterval(timerRef.current);
  }, []);

  const startTimer = () => {
    clearInterval(timerRef.current);
    setTimeLeft(300);
    timerRef.current = setInterval(() => {
      setTimeLeft((prev) => (prev > 0 ? prev - 1 : 0));
    }, 1000);
  };

  const formatTime = (seconds) => {
    const m = Math.floor(seconds / 60)
      .toString()
      .padStart(2, "0");
    const s = (seconds % 60).toString().padStart(2, "0");
    return `${m}:${s}`;
  };

  const handleChange = (e, index) => {
    const value = e.target.value;
    if (/^[0-9]$/.test(value)) {
      const newOtp = [...otp];
      newOtp[index] = value;
      setOtp(newOtp);
      setError("");
      if (index < 5) inputRefs.current[index + 1]?.focus();
    } else if (value === "") {
      const newOtp = [...otp];
      newOtp[index] = "";
      setOtp(newOtp);
    }
  };

  const handleKeyDown = (e, index) => {
    if (e.key === "Backspace") {
      const newOtp = [...otp];
      if (newOtp[index]) {
        newOtp[index] = "";
        setOtp(newOtp);
      } else if (index > 0) {
        inputRefs.current[index - 1]?.focus();
      }
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const enteredOTP = otp.join("");
    if (enteredOTP.length < 6 || otp.includes("")) {
      setError("Please enter the 6-digit OTP.");
      return;
    }
    onSubmit(enteredOTP);
  };

  const handleResendOTP = () => {
    resendOTP(); // parent resend function
    setOtp(new Array(6).fill("")); // clear old otp
    setError("");
    inputRefs.current[0]?.focus();
    startTimer(); // restart countdown
  };

  const Spinner = () => (
    <span
      className="spinner-border spinner-border-sm me-2"
      role="status"
      aria-hidden="true"
    ></span>
  );

  return (
    <div className="d-flex flex-column mt-48">
      <form onSubmit={handleSubmit} className="d-flex mb-3">
        {otp.map((digit, index) => (
          <input
            key={index}
            type="text"
            inputMode="numeric"
            maxLength="1"
            className="otp-box"
            value={digit}
            ref={(el) => (inputRefs.current[index] = el)}
            onChange={(e) => handleChange(e, index)}
            onKeyDown={(e) => handleKeyDown(e, index)}
            style={{ width: "48px", height: "48px", fontSize: "20px" }}
          />
        ))}
      </form>

      {timeLeft > 0 ? (
        <>
          <div>
            Not received your code? <b>{formatTime(timeLeft)}</b>
          </div>
          {error && <div className="text-danger mt-2">{error}</div>}

          <div className="hstack gap-5 mt-48">
            <button
              className="btn btn-main py-18 px-40 mt-3"
              onClick={handleSubmit}
              disabled={saving}
            >
              {saving && <Spinner />}
              {saving ? "VERIFYING..." : "VERIFY OTP"}
            </button>
          </div>
        </>
      ) : (
        <div className="hstack gap-5 mt-48">
          <button
            className="btn btn-main py-18 px-40 mt-3"
            onClick={handleResendOTP}
            disabled={saving}
          >
            {saving && <Spinner />}
            {saving ? "RESENDING..." : "RESEND OTP"}
          </button>
        </div>
      )}
    </div>
  );
};
const CustomerSignup = ({ handleCustomer }) => {
  const toast = useNotification();
  const navigate = useNavigate();
  const { fetchCartCount, fetchWishlistCount } = useCart();
  const [step, setStep] = useState("signup");
  const [isB2B, setIsB2B] = useState(true);
  const [selectedRole, setSelectedRole] = useState("");
  const [gstVerified, setGstVerified] = useState(false);
  const [gstLoading, setGstLoading] = useState(false);


  //basic fields
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [name, setName] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [emailId, setEmailId] = useState("");
  const [customerType, setCustomerType] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [saving, setSaving] = useState(false);
  const [otpSent, setOtpSent] = useState(false);
  const [sentOTP, setSentOTP] = useState("");

  //B2B dealer or sub-Dealer fields
  const [shopName, setShopName] = useState("");
  const [gstNo, setgstNo] = useState("");
  const [alternativePhoneNumber, setAlternativePhoneNumber] = useState("");
  const [alternativeEmailId, setalternativeEmailId] = useState("");
  const [pinCode, setPinCode] = useState("");
  const [address1, setAddress1] = useState("");
  const [address2, setAddress2] = useState("");

  // Other B2B like Engineer,Contractor,etc...
  const [aadharNo, setAadharNo] = useState("");

  // Document Uploads Fields
  const [gstFile, setGstFile] = useState(null);
  const [aadharFile, setAadharFile] = useState(null);
  const [panFile, setPanFile] = useState(null);
  const [shopImageFile, setShopImageFile] = useState(null);
  const [documentErrors, setDocumentErrors] = useState({});

  //Errors
  const [passwordError, setPasswordError] = useState("");
  const [confirmPasswordError, setConfirmPasswordError] = useState("");
  const [nameError, setNameError] = useState("");
  const [phoneNumberError, setPhoneNumberError] = useState("");
  const [emailIdError, setEmailIdError] = useState("");
  const [customerTypeError, setCustomerTypeError] = useState("");
  const [shopNameError, setShopNameError] = useState("");
  const [alternativePhoneNumberError, setalternativePhoneNumberError] =
    useState("");
  const [alternativeEmailIdError, setalternativeEmailIdError] = useState("");
  const [pinCodeError, setPinCodeError] = useState("");
  const [address1Error, setAddress1Error] = useState("");
  const [address2Error, setAddress2Error] = useState("");
  const [aadharNoError, setAadharNoError] = useState("");
  const [gstNoError, setGstNoError] = useState("");

  const handleToggleB2B = () => {
    setIsB2B(true);
    setSelectedRole("");
    setCustomerType("");
  };
  const handleToggleB2C = () => {
    setIsB2B(false);
    setSelectedRole("");
    setCustomerType("");
  };

  const validateBaseFields = () => {
    let error = false;

    if (!password) {
      setPasswordError("Password Required");
      error = true;
    } else if (password.length < 6) {
      setPasswordError("Password must be at least 6 characters");
      error = true;
    } else {
      setPasswordError(""); // clear error if valid
    }

    if (password !== confirmPassword) {
      setConfirmPasswordError("Password does not match");
      error = true;
    } else {
      setConfirmPasswordError("");
    }
    if (!emailId) {
      setEmailIdError("EmailId Required");
      error = true;
    } else {
      setEmailIdError("");
    }

    if (!name) {
      setNameError("Name Required");
      error = true;
    } else {
      setNameError("");
    }

    if (!phoneNumber) {
      setPhoneNumberError("Phone Number Required");
      error = true;
    } else if (!validatePhoneNumber(phoneNumber)) {
      setPhoneNumberError("Invalid phone number");
      error = true;
    } else {
      setPhoneNumberError("");
    }

    if (!emailId) {
      setEmailIdError("Email required");
      error = true;
    } else if (!validateEmail(emailId)) {
      setEmailIdError("Invalid email address");
      error = true;
    } else {
      setEmailIdError("");
    }

    return !error;
  };


  const handleSignup = async () => {
    const isValid = validateBaseFields();
    if (!isValid) return;

 try {
   const res = await api.post(
     "customer/?flag=checkemail",
     { emailId }   );

   if (res?.data?.message === "email exists") {
     setEmailIdError("Email already exists");
     toast({ type: ERROR, message: "Email already exists." });
     return;
   }
 } catch (err) {
   toast({
     type: ERROR,
     message: "Something went wrong while checking email.",
   });
   return;
 }

    setSaving(true);
    try {
      const response = await api.post("/signup/?flag=sendOtp", {
        email: emailId,
        phoneNumber: String(phoneNumber).trim(),
      });

      if (response.status === 200) {
        toast({ type: SUCCESS, message: "OTP sent to your mobile number." });
        setOtpSent(true);
        setStep("otp");
      } else {
        toast({ type: ERROR, message: "Unable to send OTP." });
      }
    } catch (error) {
      toast({
        type: ERROR,
        message: error.response?.data?.message || error.message,
      });
    } finally {
      setSaving(false);
    }
  };

  const handleVerifyOTP = (enteredOTP) => {
    setSaving(true);

    api
      .post("/otp/?flag=verify", { email: emailId, otp: Number(enteredOTP) })
      .then((response) => {
        if (response.status === 200) {
          toast({ type: SUCCESS, message: "OTP verified successfully." });
          setStep("customerType");
        }
      })
      .catch((error) => {
        toast({
          type: ERROR,
          message: error.response?.data?.message || error.message,
        });
      })
      .finally(() => setSaving(false));
  };
  const handleResendOTP = async () => {
    setSaving(true);
    try {
      const response = await api.post("/signup/?flag=sendOtp", {
        email: emailId,
        phoneNumber: String(phoneNumber).trim(),
      });

      if (response.status === 200) {
        toast({ type: SUCCESS, message: "OTP sent to your mobile number." });
        setOtpSent(true);
        setStep("otp");
      } else {
        // setStep("otp");
        toast({ type: ERROR, message: "Unable to send OTP." });
      }
    } catch (error) {
      error.response
        ? toast({ type: ERROR, message: error.response.data.message })
        : toast({ type: ERROR, message: error.message });
    } finally {
      setSaving(false);
    }
  };

  const handleFileUpload = (type, file) => {
    const allowedTypes = [
      "image/jpeg",
      "image/jpg",
      "image/png",
      "image/webp",
      "application/pdf",
    ];
    const maxSize = 2 * 1024 * 1024;

    if (!allowedTypes.includes(file.type)) {
      setDocumentErrors((prev) => ({
        ...prev,
        [type]: "Unsupported file format",
      }));
      return;
    }

    if (file.size > maxSize) {
      setDocumentErrors((prev) => ({
        ...prev,
        [type]: "File too large (max 2MB)",
      }));
      return;
    }

    switch (type) {
      case "gst":
        setGstFile(file);
        break;
      case "pan":
        setPanFile(file);
        break;
      case "aadhar":
        setAadharFile(file);
        break;
      case "shopImage":
        setShopImageFile(file);
        break;
    }

    setDocumentErrors((prev) => ({ ...prev, [type]: null }));
  };

  const handleFinalSignup = (selectedType) => {
    const type = selectedType || customerType;

    if (
      selectedType &&
      typeof selectedType === "object" &&
      selectedType._reactName
    )
      // Reset errors
      setCustomerTypeError("");
    setShopNameError("");
    setGstNoError("");
    setalternativePhoneNumberError("");
    setalternativeEmailIdError("");
    setPinCodeError("");
    setAddress1Error("");
    setAddress2Error("");
    setAadharNoError("");
    setDocumentErrors({});

    let error = false;

    // B2B Validations
    if (["dealer", "sub-dealer"].includes(type)) {
      if (!shopName) {
        setShopNameError("Shop Name required");
        error = true;
      }
      if (!gstNo) {
        setGstNoError("GST Number required");
        error = true;
      }
      if (!alternativePhoneNumber) {
        setalternativePhoneNumberError("Alternate Phone required");
        error = true;
      }
      if (!alternativeEmailId) {
        setalternativeEmailIdError("Alternate Email required");
        error = true;
      }
      if (!pinCode) {
        setPinCodeError("Pincode required");
        error = true;
      }
      if (!address1) {
        setAddress1Error("Address Line 1 required");
        error = true;
      }
      if (!gstFile) {
        setDocumentErrors((prev) => ({
          ...prev,
          gst: "GST Certificate required",
        }));
        error = true;
      }
      if (!panFile) {
        setDocumentErrors((prev) => ({ ...prev, pan: "PAN Card required" }));
        error = true;
      }
      if (!aadharFile) {
        setDocumentErrors((prev) => ({
          ...prev,
          aadhar: "Aadhaar Card required",
        }));
        error = true;
      }
      if (!shopImageFile) {
        setDocumentErrors((prev) => ({
          ...prev,
          shopImage: "Shop Image required",
        }));
        error = true;
      }
    }

    if (["engineer", "contractor", "builder", "promoter"].includes(type)) {
      if (!shopName) {
        setShopNameError("Company Name required");
        error = true;
      }
      if (!gstNo) {
        setGstNoError("GST / PAN Number required");
        error = true;
      }
      if (!aadharNo) {
        setAadharNoError("Aadhaar Number required");
        error = true;
      }
      if (!panFile) {
        setDocumentErrors((prev) => ({ ...prev, pan: "PAN Card required" }));
        error = true;
      }
      if (!aadharFile) {
        setDocumentErrors((prev) => ({
          ...prev,
          aadhar: "Aadhaar Card required",
        }));
        error = true;
      }
    }

    if (error) return;

    setSaving(true);
    const formData = new FormData();

    formData.append("userId", emailId.toLowerCase().trim());
    formData.append("password", password);
    formData.append("name", name.trim());
    formData.append("phoneNumber", phoneNumber.trim());
    formData.append("emailId", emailId.toLowerCase().trim());
    formData.append("customerType", type);

    // B2B fields
    if (["dealer", "sub-dealer"].includes(type)) {
      formData.append("shopName", shopName.trim());
      formData.append("gstNo", gstNo.trim());
      formData.append("alternativePhoneNumber", alternativePhoneNumber.trim());
      formData.append("alternativeEmailId", alternativeEmailId.trim());
      formData.append("pincode", pinCode.trim());
      formData.append("address1", address1.trim());
      formData.append("address2", address2.trim());
      formData.append("gstCertificate", gstFile);
      formData.append("panCard", panFile);
      formData.append("aadharCard", aadharFile);
      formData.append("shopImage", shopImageFile);
    }

    if (["engineer", "contractor", "builder", "promoter","architect","others"].includes(type)) {
      formData.append("companyName", shopName.trim());
      formData.append("gstNo", gstNo.trim());
      formData.append("aadhaar_no", aadharNo.trim());
      formData.append("panCard", panFile);
      formData.append("aadharCard", aadharFile);
    }

    api
      .post("/signup/", formData, {
        headers: { "Content-Type": "multipart/form-data" },
      })
      .then((response) => {
        console.log("API Response:", response);
        if (response.status === 200) {
          const customer = response.data.data.user;
          const token = response.data.data.token;
          handleCustomer(customer, token);
          fetchCartCount();
          fetchWishlistCount();
          toast({
            type: SUCCESS,
            message: response.data.message || "Signup successful!",
          });
          navigate("/");
        }
      })
      .catch((error) => {
        console.error("API Error:", error);
        toast({
          type: ERROR,
          message:
            error.response?.data?.message ||
            error.message ||
            "Registration failed",
        });
      })
      .finally(() => setSaving(false));
  };

  const Spinner = () => (
    <span
      className="spinner-border spinner-border-sm me-2"
      role="status"
      aria-hidden="true"
    ></span>
  );
  // Password strength checker
  const getPasswordStrength = (password) => {
    if (password.length === 0) return "";
    if (password.length < 6) return "Weak";
    if (password.length < 10) return "Moderate";
    if (/[A-Z]/.test(password) && /[0-9]/.test(password) && /[^A-Za-z0-9]/.test(password)) {
      return "Strong";
    }
    return "Moderate";
  };


  const AutofillAddressOption = ({ pincode, onAddressFill }) => {
    useEffect(() => {
      if (pincode && pincode.length === 6) {
        fetch(`https://api.postalpincode.in/pincode/${pincode}`)
          .then((res) => res.json())
          .then((data) => {
            if (data[0]?.Status === "Success") {
              const po = data[0].PostOffice[0];
              onAddressFill({
                area: po.Name,
                district: po.District,
                state: po.State,
                country: po.Country,
              });
            }
          })
          .catch(() => { });
      }
    }, [pincode, onAddressFill]);

    return null;
  };

  const AutoFillAdress = async () => {
    if (pinCode.length !== 6) return;
    try {
      const response = await fetch(
        `https://api.postalpincode.in/pincode/${pinCode}`
      );
      const data = await response.json();

      if (data[0]?.Status === "Success") {
        const po = data[0].PostOffice[0];
        const area = po.Name; // e.g., "Koramangala"
        const cityState = `${po.District}, ${po.State}`; // e.g., "Bengaluru, Karnataka"

        setAddress1(area);
        setAddress2(cityState);

        toast({
          type: SUCCESS,
          message: "Address auto-filled!",
        });
      } else {
        toast({
          type: ERROR,
          message: "Invalid pincode",
        });
      }
    } catch (err) {
      toast({
        type: ERROR,
        message: "Failed to fetch address",
      });
    }
  }

  const handleVerifyGST = async () => {
    if (!gstNo) {
      setGstNoError("Enter GST Number");
      return;
    }

    setGstLoading(true);

    try {
      const res = await api.get(`/verify_gst/?gstNumber=${gstNo}`);

      if (res?.data?.data) {
        const data = res.data.data;

        setShopName(data.name || "");
        setAddress1(data.address1 || "");
        setAddress2(data.address2 || "");
        setPinCode(data.pincode || "");

        setGstVerified(true);

        toast({
          type: SUCCESS,
          message: "GST Verified & Details Fetched",
        });
      } else {
        setGstVerified(false);
        toast({
          type: ERROR,
          message: "Invalid GST Number",
        });
      }
    } catch (err) {
      setGstVerified(false);
      toast({
        type: ERROR,
        message: "GST verification failed",
      });
    } finally {
      setGstLoading(false); 
    }
  };

  return (
    <Layout>
      <br />
      <section className="account pb-40">
        <div className="container min-h-screen align-items-center justify-content-center">
          <div className="border border-gray-100 hover-border-main-600 transition-1 rounded-16">
            {step === "signup" && (
              <div
                className="container-fluid p-0"
                style={{ overflow: "hidden", height: "100hv" }}
              >
                <div className="row g-0 align-items-center">
                  <div
                    className="col-md-6 d-flex justify-content-center align-item-center"
                    style={{
                      backgroundColor: "#F8F8F8",
                      borderTopLeftRadius: "20px",
                      borderBottomLeftRadius: "20px",
                      height: "1000px",
                      paddingTop: "200px",
                    }}
                  >
                    <LoginSlide />
                  </div>
                  <div className="col-md-6 px-24 py-40">
                    <form action="#">
                      <h6 className="text-xl mb-32 fw-bold">
                        CREATE YOUR ACCOUNT
                      </h6>

                      <div className="mb-24">
                        <label className="text-dark mb-8 fw-medium fw-bold">
                          Name
                          <span className="text-danger">*</span>
                        </label>
                        <input
                          type="text"
                          placeholder="Enter Name"
                          className={`common-input form-control ${
                            nameError !== "" ? "border-danger" : ""
                          }`}
                          id="name"
                          onChange={(e) => setName(e.target.value)}
                          value={name}
                          autoComplete="off"
                        />
                        <div
                          className="fw-bold text-danger text-capitalize small"
                          style={{ height: "10px" }}
                        >
                          {nameError}
                        </div>
                        <br />
                        <label className="text-dark mb-8 fw-medium fw-bold">
                          Email
                          <span className="text-danger">*</span>
                        </label>
                        <input
                          type="text"
                          placeholder="Enter Email Id"
                          className={`common-input form-control ${
                            emailIdError !== "" ? "border-danger" : ""
                          }`}
                          id="emailId"
                          onChange={(e) => setEmailId(e.target.value)}
                          value={emailId}
                          autoComplete="off"
                        />
                        <div
                          className="fw-bold text-danger text-capitalize small"
                          style={{ height: "10px" }}
                        >
                          {emailIdError}
                        </div>
                        <br />
                        <label className="text-dark mb-8 fw-medium fw-bold">
                          Password <span className="text-danger">*</span>
                        </label>
                        <div className="position-relative">
                          <input
                            type={showPassword ? "text" : "password"}
                            placeholder="Enter Password"
                            className={`common-input form-control ${
                              passwordError !== "" ? "border-danger" : ""
                            }`}
                            id="password"
                            onChange={(e) => {
                              setPassword(e.target.value);
                            }}
                            value={password}
                          />
                          <i
                            className={`toggle-password position-absolute top-50 translate-middle-y inset-inline-end-0 me-16 cursor-pointer ph ${
                              showPassword ? "ph-eye" : "ph-eye-slash"
                            }`}
                            onClick={() => setShowPassword(!showPassword)}
                            style={{ fontSize: "18px" }}
                          />
                        </div>

                        {/* Password messages */}
                        <div
                          className="d-flex justify-content-between mt-1"
                          style={{ fontSize: "14px" }}
                        >
                          <span style={{ fontWeight: "600" }}>
                            <a className="text-decoration-none">
                              {" "}
                              Atleast 8 characters
                            </a>
                          </span>

                          <span
                            style={{
                              color:
                                getPasswordStrength(password) === "Strong"
                                  ? "green"
                                  : getPasswordStrength(password) === "Moderate"
                                    ? "orange"
                                    : "red",
                              fontWeight: "600",
                            }}
                          >
                            {getPasswordStrength(password)}
                          </span>
                        </div>

                        <div
                          className="fw-bold text-danger text-capitalize small"
                          style={{ height: "10px" }}
                        >
                          {passwordError}
                        </div>
                        <br />
                        <label className="text-dark mb-8 fw-medium fw-bold">
                          Confirm Password
                          <span className="text-danger">*</span>
                        </label>
                        <div className="position-relative">
                          <input
                            type={showPassword ? "text" : "password"}
                            placeholder="Enter Confirm Password"
                            className={`common-input form-control ${
                              confirmPasswordError !== "" ? "border-danger" : ""
                            }`}
                            id="password"
                            onChange={(e) => setConfirmPassword(e.target.value)}
                            value={confirmPassword}
                          />
                          <i
                            className={`toggle-password position-absolute top-50 translate-middle-y inset-inline-end-0 me-16 cursor-pointer ph ${
                              showPassword ? "ph-eye" : "ph-eye-slash"
                            }`}
                            onClick={() => setShowPassword(!showPassword)}
                            style={{ fontSize: "18px" }}
                          />
                        </div>

                        <div
                          className="fw-bold text-danger text-capitalize small"
                          style={{ height: "10px" }}
                        >
                          {confirmPasswordError}
                        </div>
                        <br />
                        <label className="text-dark mb-8 fw-medium fw-bold">
                          Phone Number
                          <span className="text-danger">*</span>
                        </label>
                        <input
                          type="tel"
                          placeholder="Enter Phone Number"
                          className={`common-input form-control ${
                            phoneNumberError !== "" ? "border-danger" : ""
                          }`}
                          id="phoneNumber"
                          onChange={(e) => setPhoneNumber(e.target.value)}
                          value={phoneNumber}
                          autoComplete="off"
                        />
                        <div
                          className="fw-bold text-danger text-capitalize small"
                          style={{ height: "10px" }}
                        >
                          {phoneNumberError}
                        </div>
                        <br />
                        <div>
                          By continuing, you agree to Buildton's{" "}
                          <a className="text-decoration-none">Terms of Use</a>{" "}
                          and{" "}
                          <a className="text-decoration-none">Privacy Policy</a>
                        </div>
                      </div>

                      <div className="mb-24 mt-48">
                        <button
                          type="button"
                          className="btn btn-main py-18 px-40"
                          onClick={handleSignup}
                          disabled={saving}
                        >
                          {saving && <Spinner />}
                          {saving ? "Processing..." : "REQUEST OTP"}
                        </button>
                      </div>

                      <div className="mt-48">
                        <div className="mt-32">
                          <Link
                            to="/login"
                            className="text-success fw-semibold hover-text-decoration-underline"
                          >
                            Already a customer? Login
                          </Link>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            )}
            {step === "otp" && (
              <div
                className="container-fluid p-0"
                style={{ overflow: "hidden" }}
              >
                <div className="row g-0 align-items-center">
                  <div
                    className="col-md-6 d-flex m-0"
                    style={{
                      backgroundColor: "#F8F8F8",
                      borderTopLeftRadius: "18px",
                      borderBottomLeftRadius: "18px",
                    }}
                  >
                    <div className="d-flex flex-column justify-content-center align-items-center text-center w-100 h-100 pb-40 pt-40">
                      <img
                        src="/assets/images/Signup1.png"
                        alt="Slide 1"
                        style={{
                          maxHeight: "350px",
                          objectFit: "contain",
                          marginBottom: "20px",
                        }}
                      />
                    </div>
                  </div>
                  <div className="col-md-6 px-24 py-40">
                    <form action="#">
                      <h6 className="text-xl mb-32 fw-bold">
                        CREATE YOUR ACCOUNT
                      </h6>
                      <div className="form-group mb-24">
                        <div className="d-flex justify-content-between">
                          <label className="text-dark mb-8 fw-medium fw-bold">
                            Please Enter the OTP sent to +91{phoneNumber}
                            <span className="text-danger">*</span>
                          </label>
                          <span>
                            <a
                              className="text-decoration-none cursor-pointer"
                              onClick={() => setStep("signup")}
                            >
                              Change
                            </a>
                          </span>
                        </div>
                        <OTPInput
                          onSubmit={handleVerifyOTP}
                          resendOTP={handleResendOTP}
                          sentOTP={sentOTP}
                          saving={saving}
                        />
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            )}
            {step === "customerType" && (
              <div
                className="container-fluid p-0"
                style={{ overflow: "hidden", height: "100hv" }}
              >
                <div className="row g-0 ">
                  <div
                    className={
                      isB2B && customerType
                        ? "col-md-6 d-flex justify-content-center align-items-center"
                        : isB2B && !customerType
                          ? "col-md-6 d-flex justify-content-center align-items-center"
                          : "col-md-6"
                    }
                    style={
                      isB2B && customerType
                        ? {
                            backgroundColor: "#F8F8F8",
                            borderTopLeftRadius: "20px",
                            borderBottomLeftRadius: "20px",
                            height: "auto",
                          }
                        : isB2B && !customerType
                          ? {
                              backgroundColor: "#F8F8F8",
                              borderTopLeftRadius: "20px",
                              borderBottomLeftRadius: "20px",
                              height: "auto",
                            }
                          : {}
                    }
                  >
                    <LoginSlide />
                  </div>
                  <div className="col-md-6 px-24 py-40">
                    {!customerType && (
                      <h6 className="text-xl mb-32 fw-bold">
                        CHOOSE YOUR LOGIN
                      </h6>
                    )}
                    {/* Step 1: B2C vs B2B Toggle */}
                    {!customerType && (
                      <div className=" gap-1 mb-5">
                        <div className="container px-2 py-1">
                          <div className="d-flex ">
                            <div className="">
                              <button
                                type="button"
                                className={` btn-b2b-toggle ${
                                  isB2B ? "active" : ""
                                }`}
                                onClick={handleToggleB2B}
                                style={{
                                  width: "250px",
                                  height: "60px",
                                  color: "black",
                                }}
                              >
                                <span style={{ color: "black" }}>B2B</span>
                              </button>
                            </div>
                            <div className="">
                              <button
                                type="button"
                                className={`btn-b2c-toggle ${
                                  !isB2B ? "active" : ""
                                }`}
                                onClick={handleToggleB2C}
                                style={{
                                  width: "250px",
                                  height: "60px",
                                  color: "black",
                                }}
                              >
                                <span style={{ color: "black" }}>B2C</span>
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    )}

                    {/* Step 2: Show B2C - Individual */}
                    {!isB2B && !customerType && (
                      <div className="mb-1">
                        <div className="container px-5 py-5">
                          <div className="row d-flex justify-content-center align-items-center">
                            <div className="mt-10">
                              <button
                                className={`btn-btn-select-role  ${
                                  selectedRole === "individual"
                                    ? "selected-role-btn"
                                    : ""
                                }`}
                                onClick={() => setSelectedRole("individual")}
                                style={{ width: "250px", height: "60px" }}
                              >
                                Individual
                              </button>
                            </div>
                          </div>

                          {/* Continue Button for B2C */}

                          <div className="mt-48">
                            <button
                              type="button"
                              className="btn btn-main py-18 px-40"
                              onClick={() => {
                                if (!selectedRole) {
                                  toast({
                                    type: ERROR,
                                    message:
                                      "Please select a role before continuing",
                                  });
                                  return;
                                }
                                setCustomerType("individual");
                                handleFinalSignup("individual");
                              }}
                              disabled={saving}
                            >
                              {saving ? "LOADING..." : "CONTINUE"}
                            </button>
                          </div>

                          <div className="mt-32">
                            <Link
                              to="/login"
                              className="text-success fw-semibold"
                            >
                              Already a customer? Login
                            </Link>
                          </div>
                        </div>
                      </div>
                    )}
                    {/* Step 3: Show B2B Types */}
                    {isB2B && !customerType && (
                      <div className="mb-1">
                        <div className="container px-1 py-3">
                          <div
                            className="d-flex flex-wrap mt-10"
                            style={{
                              gap: "8px",
                              marginLeft: "-4px",
                              marginRight: "-4px",
                            }}
                          >
                            {[
                              "dealer",
                              "sub-dealer",
                              "engineer",
                              "architect",
                              "contractor",
                              "builder",
                              "promoter",
                              "others",
                            ].map((type) => (
                              <div
                                className=" mb-3"
                                key={type}
                                style={{
                                  textAlign: "center",
                                  maxWidth: "calc(50% - 8px)",
                                }}
                              >
                                <label
                                  className={`form-control btn-btn-select-role rounded-5 ${
                                    selectedRole === type
                                      ? "selected-role-btn"
                                      : ""
                                  }`}
                                  onClick={() => setSelectedRole(type)}
                                  style={{
                                    width: "250px",
                                    padding: "20px",
                                    cursor: "pointer",
                                  }}
                                >
                                  {type.charAt(0).toUpperCase() + type.slice(1)}
                                </label>
                              </div>
                            ))}
                          </div>
                          <div className="mt-48">
                            <button
                              type="button"
                              className="btn btn-main py-18 px-40"
                              onClick={() => {
                                if (!selectedRole) return;
                                setCustomerType(selectedRole);
                              }}
                              disabled={saving}
                            >
                              {saving ? "LOADING..." : "CONTINUE"}
                            </button>
                          </div>

                          {/* Login Link */}
                          <div className="mt-32">
                            <Link
                              to="/login"
                              className="text-success fw-semibold hover-text-decoration-underline"
                            >
                              Already a customer? Login
                            </Link>
                          </div>
                        </div>
                      </div>
                    )}

                    {/* Step 4: Show B2B Form (only after selecting a B2B type) */}
                    {isB2B && customerType && (
                      <>
                        <div className="mt-1 ">
                          <h6 className="text-xl mb-32 fw-bold">
                            Enter Your Details
                          </h6>

                          {/* Dealer/Sub-dealer Fields */}
                          {["dealer", "sub-dealer"].includes(customerType) && (
                            <>
                              {/* <div className="mb-24">
                                <label className="text-dark mb-8 fw-medium fw-bold">
                                  GST Number
                                  <span className="text-danger">*</span>
                                </label>
                                <input
                                  type="text"
                                  className={`common-input form-control ${gstNoError ? "border-danger" : ""
                                    }`}
                                  value={gstNo}
                                  placeholder="Enter Gst Number"
                                  onChange={(e) => setgstNo(e.target.value)}
                                />
                                <div className="text-danger small">
                                  {gstNoError}
                                </div>
                              </div> */}

                              <div className="mb-24">
                                <label className="text-dark mb-8 fw-medium fw-bold">
                                  GST Number{" "}
                                  <span className="text-danger">*</span>
                                </label>

                                <div className="position-relative">
                                  <input
                                    type="text"
                                    className={`common-input form-control pe-80 ${
                                      gstNoError ? "border-danger" : ""
                                    }`}
                                    value={gstNo}
                                    placeholder="Enter GST Number"
                                    onChange={(e) => {
                                      setgstNo(e.target.value);
                                      setGstVerified(false);
                                    }}
                                    style={{ paddingRight: "90px" }}
                                  />

                                  <button
                                    type="button"
                                    onClick={handleVerifyGST}
                                    disabled={gstLoading}
                                    className="position-absolute top-50 end-0 translate-middle-y me-2"
                                    style={{
                                      color: "#0000FF",
                                      padding: "4px 10px",
                                      fontSize: "12px",
                                      borderRadius: "6px",
                                    }}
                                  >
                                    {gstLoading ? (
                                      <span className="spinner-border spinner-border-sm"></span>
                                    ) : (
                                      "Verify"
                                    )}
                                  </button>
                                </div>

                                <div className="text-danger small">
                                  {gstNoError}
                                </div>
                              </div>

                              <div className="mb-24">
                                <label className="text-dark mb-8 fw-medium fw-bold">
                                  Shop Name
                                  <span className="text-danger">*</span>
                                </label>
                                <input
                                  type="text"
                                  className={`common-input form-control ${
                                    shopNameError ? "border-danger" : ""
                                  }`}
                                  value={shopName}
                                  placeholder="Enter Shop Name"
                                  onChange={(e) => setShopName(e.target.value)}
                                  readOnly
                                  style={{
                                    cursor: "not-allowed",
                                    border: "1px solid #E6E6E6",
                                  }}
                                />
                                <div className="text-danger small">
                                  {shopNameError}
                                </div>
                              </div>
                              <div className="mb-24">
                                <label className="text-dark mb-8 fw-medium fw-bold">
                                  Alternate Phone Number
                                  <span className="text-danger">*</span>
                                </label>
                                <input
                                  type="text"
                                  className={`common-input form-control ${
                                    alternativePhoneNumberError
                                      ? "border-danger"
                                      : ""
                                  }`}
                                  value={alternativePhoneNumber}
                                  placeholder="Enter Alternate Phone Number"
                                  onChange={(e) =>
                                    setAlternativePhoneNumber(e.target.value)
                                  }
                                />
                                <div className="text-danger small">
                                  {alternativePhoneNumberError}
                                </div>
                              </div>
                              <div className="mb-24">
                                <label className="text-dark mb-8 fw-medium fw-bold">
                                  Alternate Email
                                  <span className="text-danger">*</span>
                                </label>
                                <input
                                  type="email"
                                  className={`common-input form-control ${
                                    alternativeEmailIdError
                                      ? "border-danger"
                                      : ""
                                  }`}
                                  value={alternativeEmailId}
                                  placeholder="Enter Altenate Email "
                                  onChange={(e) =>
                                    setalternativeEmailId(e.target.value)
                                  }
                                />
                                <div className="text-danger small">
                                  {alternativeEmailIdError}
                                </div>
                              </div>

                              <div className="mb-24">
                                <label className="text-dark mb-8 fw-medium fw-bold">
                                  Pincode <span className="text-danger">*</span>
                                </label>
                                <div className="position-relative">
                                  <input
                                    type="text"
                                    maxLength="6"
                                    className={`common-input form-control ${
                                      pinCodeError ? "border-danger" : ""
                                    }`}
                                    value={pinCode}
                                    style={{
                                      cursor: "not-allowed",
                                      border: "1px solid #E6E6E6",
                                    }}
                                    placeholder="Enter Pincode"
                                    onChange={(e) => {
                                      const value = e.target.value;
                                      if (
                                        /^\d*$/.test(value) &&
                                        value.length <= 6
                                      ) {
                                        setPinCode(value);
                                        // Clear auto-filled data if pincode changes
                                        if (value.length !== 6) {
                                          setAddress1("");
                                          setAddress2("");
                                        }
                                      }
                                    }}
                                    readOnly
                                    // style={{ paddingRight: "70px" }} // Make space for button
                                  />
                                  <button
                                    type="button"
                                    className="btn btn-sm text-primary position-absolute end-0 top-50 translate-middle-y"
                                    onClick={AutoFillAdress}
                                    disabled={pinCode.length !== 6}
                                    style={{
                                      padding: "0 12px",
                                      fontSize: "12px",
                                      border: "none",
                                      background: "transparent",
                                      cursor: "pointer",
                                    }}
                                  >
                                    <span style={{ color: "blue" }}>
                                      Autofill Address
                                    </span>
                                  </button>
                                </div>
                                <div className="text-danger small">
                                  {pinCodeError}
                                </div>
                              </div>
                              <div className="mb-24">
                                <label className="text-dark mb-8 fw-medium fw-bold">
                                  Address Line 1
                                  <span className="text-danger">*</span>
                                </label>
                                <input
                                  type="text"
                                  className={`common-input form-control ${
                                    address1Error ? "border-danger" : ""
                                  }`}
                                  value={address1}
                                  placeholder="Enter Address Line 1"
                                  onChange={(e) => setAddress1(e.target.value)}
                                  readOnly
                                  style={{
                                    cursor: "not-allowed",
                                    border: "1px solid #E6E6E6",
                                  }}
                                />
                                <div className="text-danger small">
                                  {address1Error}
                                </div>
                              </div>
                              <div className="mb-24">
                                <label className="text-dark mb-8 fw-medium fw-bold">
                                  Address Line 2
                                  <span className="text-danger">*</span>
                                </label>
                                <input
                                  type="text"
                                  className={`common-input form-control ${
                                    address2Error ? "border-danger" : ""
                                  }`}
                                  value={address2}
                                  placeholder="Enter Address Line 2"
                                  onChange={(e) => setAddress2(e.target.value)}
                                  style={{
                                    cursor: "not-allowed",
                                    border: "1px solid #E6E6E6",
                                  }}
                                  readOnly
                                />
                                <div className="text-danger small">
                                  {address2Error}
                                </div>
                              </div>
                            </>
                          )}

                          {/* Engineer/Contractor/Builder/Promoter Fields */}
                          {[
                            "engineer",
                            "contractor",
                            "builder",
                            "promoter",
                            "architect",
                            "others",
                          ].includes(customerType) && (
                            <>
                              <div className="mb-24">
                                <label className="text-dark mb-8 fw-medium fw-bold">
                                  Company Name
                                  <span className="text-danger">*</span>
                                </label>
                                <input
                                  type="text"
                                  className={`common-input form-control ${
                                    shopNameError ? "border-danger" : ""
                                  }`}
                                  value={shopName}
                                  placeholder="Enter Company Name"
                                  onChange={(e) => setShopName(e.target.value)}
                                />
                                <div className="text-danger small">
                                  {shopNameError}
                                </div>
                              </div>
                              <div className="mb-24">
                                <label className="text-dark mb-8 fw-medium fw-bold">
                                  GST / PAN Number
                                  <span className="text-danger">*</span>
                                </label>
                                <input
                                  type="text"
                                  className={`common-input form-control ${
                                    gstNoError ? "border-danger" : ""
                                  }`}
                                  value={gstNo}
                                  placeholder="Enter GST / PAN Number"
                                  onChange={(e) => setgstNo(e.target.value)}
                                />
                                <div className="text-danger small">
                                  {gstNoError}
                                </div>
                              </div>
                              <div className="mb-24">
                                <label className="text-dark mb-8 fw-medium fw-bold">
                                  Aadhaar Number
                                  <span className="text-danger">*</span>
                                </label>
                                <input
                                  type="text"
                                  className={`common-input form-control ${
                                    aadharNoError ? "border-danger" : ""
                                  }`}
                                  value={aadharNo}
                                  placeholder="Enter Aadhaar Number"
                                  onChange={(e) => setAadharNo(e.target.value)}
                                />
                                <div className="text-danger small">
                                  {aadharNoError}
                                </div>
                              </div>
                            </>
                          )}

                          {/* Document Uploads */}
                          <div className="mt-4">
                            <p className="text-dark mb-8 fw-medium fw-bold">
                              Upload Documents
                              <span className="text-danger">*</span>
                            </p>
                            <div className="d-flex gap-3 flex-wrap">
                              {["dealer", "sub-dealer"].includes(
                                customerType,
                              ) && (
                                <>
                                  <DocumentUpload
                                    name="GST Certificate"
                                    file={gstFile}
                                    onUpload={(f) => handleFileUpload("gst", f)}
                                    error={documentErrors.gst}
                                  />
                                  <DocumentUpload
                                    name="PAN Card"
                                    file={panFile}
                                    onUpload={(f) => handleFileUpload("pan", f)}
                                    error={documentErrors.pan}
                                  />
                                  <DocumentUpload
                                    name="Aadhaar Card"
                                    file={aadharFile}
                                    onUpload={(f) =>
                                      handleFileUpload("aadhar", f)
                                    }
                                    error={documentErrors.aadhar}
                                  />
                                  <DocumentUpload
                                    name="Shop Image"
                                    file={shopImageFile}
                                    onUpload={(f) =>
                                      handleFileUpload("shopImage", f)
                                    }
                                    error={documentErrors.shopImage}
                                  />
                                </>
                              )}
                              {[
                                "engineer",
                                "contractor",
                                "builder",
                                "promoter",
                              ].includes(customerType) && (
                                <>
                                  <DocumentUpload
                                    name="PAN Card"
                                    file={panFile}
                                    onUpload={(f) => handleFileUpload("pan", f)}
                                    error={documentErrors.pan}
                                  />
                                  <DocumentUpload
                                    name="Aadhaar Card"
                                    file={aadharFile}
                                    onUpload={(f) =>
                                      handleFileUpload("aadhar", f)
                                    }
                                    error={documentErrors.aadhar}
                                  />
                                </>
                              )}
                            </div>
                          </div>
                          <div className="mb-24 mt-48">
                            <button
                              type="button"
                              className="btn btn-main py-18 px-40"
                              onClick={() => handleFinalSignup(customerType)}
                              disabled={saving}
                            >
                              {saving && <Spinner />}{" "}
                              {saving ? "LOADING..." : "CONTINUE"}
                            </button>
                          </div>
                          <div className="mt-48">
                            <div className="mt-32">
                              <Link
                                to="/login"
                                className="text-success fw-semibold hover-text-decoration-underline"
                              >
                                Already a customer? Login
                              </Link>
                            </div>
                          </div>
                        </div>
                      </>
                    )}
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </section>
    </Layout>
  );
};

const DocumentUpload = ({ name, file, onUpload, error }) => {
  const fileInputRef = useRef();

  const handleClick = () => fileInputRef.current?.click();

  const handleChange = (e) => {
    if (e.target.files.length > 0) {
      onUpload(e.target.files[0]);
    }
  };

  const handlePreview = (e) => {
    e.stopPropagation(); // Prevent opening file picker
    if (file) {
      const url = URL.createObjectURL(file);
      window.open(url, "_blank"); // Open in new tab
    }
  };

  return (
    <div
      className={`cursor-pointer text-center position-relative ${file ? " border-Orange-500" : "bg-white border-gray-300"
        }`}
      onClick={handleClick}
      style={{ width: "140px", height: "120px" }}
    >
      {!file ? (
        // Default state: Show upload icon and text
        <div className="d-flex flex-column align-items-center justify-content-center h-100">
          <UploadCloud size={24} color={file ? "#FF8C00" : "#6c757d"} />
          <p className="text-muted mb-1" style={{ fontSize: "12px" }}>
            {name}
          </p>
        </div>
      ) : (
        <div className="d-flex flex-column align-items-center justify-content-center h-100">
          <p className="text-orange mb-2" style={{ fontSize: "12px" }}>
            {name}
          </p>

          <button
            type="button"
            className="btn btn-sm text-white mt-5"
            onClick={handlePreview}
            style={{
              backgroundColor: "#FF8C00",
              borderColor: "#FF8C00",
              fontSize: "12px",
              padding: "4px 8px",
            }}
          >
            Preview
          </button>
        </div>
      )}

      {/* Error message */}
      {error && <div className="text-danger small mt-2">{error}</div>}

      {/* Hidden file input */}
      <input
        type="file"
        accept=".jpg,.jpeg,.png,.webp,.pdf"
        ref={fileInputRef}
        onChange={handleChange}
        className="d-none"
      />
    </div>
  );
};

export default CustomerSignup;
